// extracted by mini-css-extract-plugin
export var fulfillmentPanel = "_hw-0";
export var fulfillmentPanelBody = "_hw-1";